import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import HostingZoneSelector from './HostingZoneSelector'
import {hostingZone} from '../../../constants'
import ContextEditor from './ContextEditor'
import {connect} from '../../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getContext,
    getContextCheckingStatus,
    getHostingZone,
    getLockedZone,
    isContextChanged,
    isContextInUse,
    isContextInvalid,
    isHostingZoneChanged
} from '../selectors'
import {changeContext, changeHostingZone} from '../actions'

class ConfigureAccountInfoStep extends TemplateView {
    constructor({
        changeHostingZone = () => {},
        changeContext = () => {},
    } = {}) {
        super()

        this.actions = {
            changeHostingZone,
            changeContext,
        }

        this.state = {
            hostingZone: '',
            hostingZoneChanged: false,
            lockedZone: null,
            context: '',
            isContextChanged: false,
            contextInUse: false,
            contextInvalid: false,
            contextCheckingStatus: null,
        }

        this.onStatePropertyChanged('hostingZone', (hostingZone) => this.hostingZoneSelector.setState({hostingZone}))

        this.onStatePropertyChanged('lockedZone', (lockedZone) => {
            const euOnly = lockedZone === hostingZone.EUROPE
            this.hostingZoneSelector.setState({euOnly})
            this.$hostingZoneSectionTitle.text(messageResource.getMessage(
                euOnly ? 'licenses.purchase_lightbox.choose_hosting_zone.title_europe_only'
                       : 'licenses.purchase_lightbox.choose_hosting_zone.title')
            )
        })

        this.onAnyStatePropertyChanged([
            'hostingZone', 'hostingZoneChanged',
            'context', 'isContextChanged', 'contextInUse', 'contextInvalid', 'contextCheckingStatus'
        ], () => {
            this.contextEditor.setState({
                hostingZone: this.state.hostingZone,
                hostingZoneChanged: this.state.hostingZoneChanged,
                context: this.state.context,
                isContextChanged: this.state.isContextChanged,
                contextInUse: this.state.contextInUse,
                contextInvalid: this.state.contextInvalid,
                contextCheckingStatus: this.state.contextCheckingStatus,
            })
        })
    }

    templateHtml() {
        return '<div class="configureAccountInfo">' +
               '    <div class="hostingZoneSection">' +
               '        <div class="title"><%=chooseHostingZoneTitle%></div>' +
               '        <div class="hostingZoneSelectorContainer"/>' +
               '    </div>' +
               '    <div class="contextSection">' +
               '        <div class="title"><%=reviewContextTitle%></div>' +
               '        <div class="contextEditorContainer"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            chooseHostingZoneTitle: 'licenses.purchase_lightbox.choose_hosting_zone.title',
            reviewContextTitle: 'licenses.purchase_lightbox.review_context',
        }
    }

    afterRender() {
        this.$hostingZoneSectionTitle = this.find('.hostingZoneSection .title')

        this.hostingZoneSelector = new HostingZoneSelector({
            onHostingZoneChanged: this.actions.changeHostingZone,
        }).init(this.find('.hostingZoneSelectorContainer'))

        this.contextEditor = new ContextEditor({
            onContextChanged: this.actions.changeContext,
        }).init(this.find('.contextEditorContainer'))
    }
}

export default connect(
    (state) => ({
        hostingZone: getHostingZone(state),
        hostingZoneChanged: isHostingZoneChanged(state),
        lockedZone: getLockedZone(state),
        context: getContext(state),
        isContextChanged: isContextChanged(state),
        contextInUse: isContextInUse(state),
        contextInvalid: isContextInvalid(state),
        contextCheckingStatus: getContextCheckingStatus(state),

    }),
    (dispatch) => ({
        changeHostingZone: bindActionCreators(changeHostingZone, dispatch),
        changeContext: bindActionCreators(changeContext, dispatch),
    })
)(ConfigureAccountInfoStep)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/accountInfo/ConfigureAccountInfoStep.js